import { createStyles } from 'antd-style';

import {
  ThemeBorderRadius,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../theme';

export const useQuoteStyles = createStyles(({ token }) => ({
  // Base card shared by QuoteSummaryHeader and QuoteRoutingDialog (no owning
  // component — both independently render their own `<Card>` with this
  // styling). Each file adds its own overrides on top via classNames.
  quoteSummaryHeaderCard: {
    padding: 0,
    height: 80,
    backgroundColor: ThemeColors.COLOR_WHITE2,
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_MD,
    border: `1px solid ${token.colorWhite}`,
    boxShadow: `6px 6px 15px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY8_7, 0.85)}, -1px -1px 1px ${token.colorWhite}`,

    [`@media (max-width: ${token.screenSMMax}px)`]: {
      height: 60,
    },

    '.ant-card-body': {
      padding: `${token.paddingSM}px ${ThemeSpaces.SPACE_NORM_20}px`,

      [`@media (max-width: ${token.screenLGMax}px)`]: {
        padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
      },
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        padding: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px`,
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        padding: `${token.paddingSM}px 7px`,
      },
    },

    h1: {
      color: ThemeColors.COLOR_GREY3,
      font: `400 48px ${ThemeFont.FONT_FAMILY6}`,
      letterSpacing: 0.4,
      textTransform: 'uppercase',
      margin: '-8px 0 -2px 0',

      [`@media (min-width: ${token.screenXLMin}px) and (max-width: ${token.screenXLMax}px)`]:
        {
          fontSize: 36,
          marginTop: 0,
        },
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        fontSize: 32,
        marginTop: 0,
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        fontSize: token.fontSizeHeading3,
        marginTop: 0,
      },
    },

    h2: {
      color: ThemeColors.COLOR_GREY3,
      font: `400 32px ${ThemeFont.FONT_FAMILY6}`,
      textTransform: 'uppercase',
    },

    '.InlineLink': {
      justifyContent: 'end',
      color: ThemeColors.COLOR_BLUE3,
      marginBottom: -8,

      '> span': {
        textDecoration: 'underline',
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        fontWeight: 'bold',
      },
    },
  },
  quoteIdLabel: {
    textTransform: 'uppercase',
    fontSize: token.fontSizeSM,
    fontWeight: 500,
    letterSpacing: 0,
    color: ThemeColors.COLOR_GREY11,
  },
  quoteId: {
    marginLeft: ThemeSpaces.SPACE_XS,
    color: token.colorPrimary,
  },
  shipmentInfoTitle: {
    '&&': {
      fontFamily: ThemeFont.FONT_FAMILY6,
      fontSize: token.fontSizeHeading3,
      color: ThemeColors.COLOR_GREY11,
      fontWeight: 400,
      margin: 0,

      [`@media (max-width: ${token.screenXLMax}px)`]: {
        fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
      },
    },
  },
  // No owning component — rendered directly by ShipmentDetails.jsx and
  // QuoteRoutingDialog.jsx (containers/ and forms/ layers respectively).
  shipmentStatus: {
    '&&': {
      fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
      fontWeight: 700,
      fontFamily: ThemeFont.FONT_CONDENSED,
      color: ThemeColors.COLOR_GREY3,
      marginBottom: 6,

      '> div': {
        color: token.colorPrimary,
      },

      [`@media (max-width: ${token.screenXLMax}px)`]: {
        fontSize: token.fontSizeLG,
        marginTop: ThemeSpaces.SPACE_NORM_15,
      },
    },
  },
}));
